<!--
 * @Author: wsx
 * @Date: 2022-03-05 14:24:26
 * @LastEditTime: 2022-03-05 18:29:32
 * @Description:实有车辆
 * @FilePath: \smart-community\src\views\smartApplication\threeSolidQuery\components\car.vue
-->
<template>
  <div class="car">
    <div class="search-results-box">
      <ul class="search-results">
        <template v-for="(item, index) in carlist" :key="index">
          <li class="results-item">
            <div class="item-details">
              <div class="details-info">
                <span class="label">
                  <h-button type="primary" @click="carHandlear(item)"
                    >{{ item.carProvinceDict }}{{ item.carNumber }}</h-button
                  >
                </span>
                <span class="value">{{ item.functionDict }}</span>
              </div>
              <div class="details-info">
                <span class="label">车辆类型</span>
                <span class="value">{{ item.carTypeDict }}</span>
              </div>
              <div class="details-info">
                <span class="label">车辆品牌</span>
                <span class="value">{{ item.carBrandDict }}</span>
              </div>
              <div class="details-info">
                <span class="label">车身颜色</span>
                <span class="value">{{ item.carColorDict }}色</span>
              </div>
              <div class="details-info">
                <span class="label">机动车所有人</span>
                <span class="value">
                  <el-link type="success" @click="personHandlear(item)">{{
                    item.prisonId
                  }}</el-link>
                </span>
              </div>
              <div class="details-info">
                <span class="label">初次登记日期</span>
                <span class="value">{{ item.createtime }}</span>
              </div>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs } from "vue";
import { carlist } from "@/api/realHouse/realHouse.js";
export default defineComponent({
  name: "car",
  components: {},
  emits: ["clickPerson", "carHandlear"],
  setup(props, context) {
    const data = reactive({
      carlist: []
    });
    const refData = toRefs(data);
    const personHandlear = item => {
      context.emit("clickPerson", item);
    };
    const carHandlear = item => {
      context.emit("clickCar", item);
    };
    // 请求数据
    const queryData = params => {
      console.log("car-请求数据-参数", params);
      return getcarlist(params);
    };
    const getcarlist = async search => {
      const params = {
        page: 1,
        limit: 10000
      };
      if (search) {
        params.search = search;
      }
      const res = await carlist(params);
      console.log('resresres',res);
      data.carlist = res.page.list;
      console.log(data.carlist[0]);
      return res.page.list.length;
    };
    getcarlist();
    return { ...refData, personHandlear, carHandlear, queryData, getcarlist };
  }
});
</script>
<style lang="scss" scoped>
.car {
  .search-results-box {
    width: 100%;
    flex: 1;
    height: 100%;
    overflow: auto;
  }
  .search-results {
    width: 100%;
    .results-item {
      padding: 10px 0;
      width: 100%;
      border-bottom: 1px solid #aab2c5;
      @include flex-row-s-c;
      .item-img {
        width: 100px;
        img {
          width: 100%;
        }
      }
      .item-details {
        flex: 1;
        margin-left: 10px;
        line-height: 28px;
        .details-info {
          font-size: 14px;
          @include flex-row-sb-c;
          & > span {
            display: inline-block;
          }
          .label {
            width: 120px;
          }
          .value {
            flex: 1;
          }
        }
      }
    }
  }
}
</style>
